























































































import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import ShoppingCartActions from '@/components/shopping-cart/ShoppingCartActions.vue';
import Price from '@/components/price/Price.vue';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import CatalogueSearchCardImage from '@/components/catalogue-search/CatalogueSearchCardImage.vue';
import { PartCatalogueSearchPage } from '@/entities/part-catalogue/PartCatalogueSearchPage';
import { PartCatalogueFilter } from '@/entities/part-catalogue/PartCatalogueFilter';
import { PartCatalogueBreadcrumb } from '@/entities/part-catalogue/PartCatalogueBreadcrumb';
import URI from 'urijs';
import { isNullOrWhitespace } from '@/helper/isNullOrWhitespace';
import { PartDeliveryTimeInformation } from '@/entities/PartDeliveryTimeInformation';
import { localize } from '@/filters/localize';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import { PartCatalogueSearchModuleTypes } from '../../store/modules/part-catalogue-search';
import _, { partition } from 'lodash';
import { PartCatalogueSearchPartResult } from '@/entities/part-catalogue/PartCatalogueSearchPartResult';

@Component({
    components: {
        ShoppingCartActions,
        LoadingIndicator,
        Price,
        CatalogueSearchCardImage,
        DeliveryTimeToolTip,
    },
})
export default class CatalogueSearchPartCard extends Mixins(BaseMixin) {
    @Prop(Object)
    private result!: PartCatalogueSearchPartResult;
    @Prop(String)
    private basePartCatalogueDetailsLink!: string;
    @Prop(String)
    private readonly partDetailsLink!: string;

    private reloadAvailabilityDebounced: (quantity: number) => void;

    constructor() {
        super();
        this.reloadAvailabilityDebounced = _.debounce(this.reloadAvailability, 500);
    }

    private partCatalogueDetailsLink(breadcrumb: PartCatalogueBreadcrumb): string {
        const lastFilter = breadcrumb.filters.find((filter) => filter.partCatalogueEntryId !== null);
        if (lastFilter === undefined || lastFilter.partCatalogueEntryId === null) {
            return '';
        }
        return new URI(this.basePartCatalogueDetailsLink)
            .segmentCoded(lastFilter.id.toString())
            .segmentCoded(lastFilter.partCatalogueEntryId.toString())
            .addQuery('highlightPartId', this.result.searchResultPartDetails.id)
            .toString();
    }

    private get thumbnailImageUrl(): string {
        return `/api/part-catalogue/getThumbnail/assembly?id=${this.result.associatedAssemblyPaths.thumbnailAssemblyId}`;
    }

    private get showPartAvailabilityAndPrice(): boolean {
        return this.result.partAvailability !== null && this.result.price !== null;
    }

    private partCatalogueAssemblyUrl(id: string, partId: string): string {
        return `/PartCatalogue/Assembly/${id}?preSelectedPartId=${partId}`;
    }

    private getBreadcrumbLinkText(filters: PartCatalogueFilter[]): string {
        return filters
            .map((filter) => filter.filterValue)
            .filter((value) => !isNullOrWhitespace(value))
            .join(' > ');
    }

    private quantityChanged(quantity: number): void {
        this.reloadAvailabilityDebounced(quantity);
    }

    private reloadAvailability(quantity: number): void {
        const partId = this.result.searchResultPartDetails.id;
        this.$store.dispatch(PartCatalogueSearchModuleTypes.actions.reloadPartAvailabilityForPart, {
            partId,
            quantity,
        });
    }
}
